<script>
  export default {
    props: {
      active: {
        default: false,
        type: Boolean,
      }, 
      arrow: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        activeState: this.active,
        activeArrow: this.arrow
      }
    },
    
    methods: {
      toggleActive() {
        this.activeState = !this.activeState
        this.activeArrow = !this.activeArrow
      },
    },
    render(h) {
      return this.$scopedSlots.default({
        active: this.activeState,
        click: this.toggleActive,
        arrow: this.activeArrow,
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Dropdown/Dropdown.vue